import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { UnAuthenticationError } from '@digibricks/core';
import { error, success } from './action';
import { ofType } from 'redux-observable';
import { map, delay, concatMap } from 'rxjs/operators';
export var createEpicForUseCase = function createEpicForUseCase(useCase, useCaseName, showingToastHandler, unAuthenticationHandler, handleAsyncParams, customizeEpic) {
  var type = useCaseName !== null && useCaseName !== void 0 ? useCaseName : useCase.constructor.name;

  var defaultHandle = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(action) {
      var resultOrError;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return useCase.execute(action.payload);

            case 2:
              resultOrError = _context.sent;

              if (!resultOrError.isFailure) {
                _context.next = 6;
                break;
              }

              console.error(resultOrError.error);
              return _context.abrupt("return", {
                type: "".concat(type, "_").concat(error),
                error: resultOrError,
                translation: action.translation,
                meta: {
                  input: action.payload
                }
              });

            case 6:
              return _context.abrupt("return", {
                type: "".concat(type, "_").concat(success),
                payload: resultOrError.getValue(),
                translation: action.translation,
                meta: {
                  input: action.payload
                }
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function defaultHandle(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var toastHandler = function toastHandler(action) {
    if (showingToastHandler) showingToastHandler(action);
    return action;
  };

  var unAuthenticationToastHandler = function unAuthenticationToastHandler(action) {
    if (action.error instanceof UnAuthenticationError) {
      if (unAuthenticationHandler) {
        unAuthenticationHandler();
        return action;
      }
    }

    return action;
  };

  var handle = handleAsyncParams !== null && handleAsyncParams !== void 0 ? handleAsyncParams : defaultHandle;

  var defaultEpic = function defaultEpic(action$) {
    return action$.pipe(ofType(type), concatMap( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(action) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return handle(action);

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }()), delay(500), map(function (action) {
      return toastHandler(action);
    }), map(function (action) {
      return unAuthenticationToastHandler(action);
    }), map(function (action) {
      return action;
    }));
  };

  return customizeEpic !== null && customizeEpic !== void 0 ? customizeEpic : defaultEpic;
};